import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanToYesNo',
  standalone: true,
})
export class BooleanToYesNoPipe implements PipeTransform {
  transform(value: boolean | null | undefined): string {
    return value === true ? 'Yes' : 'No';
  }
}
